import { render, staticRenderFns } from "./ShapePath.vue?vue&type=template&id=a1a2242e&scoped=true&"
import script from "./ShapePath.vue?vue&type=script&lang=js&"
export * from "./ShapePath.vue?vue&type=script&lang=js&"
import style0 from "./ShapePath.vue?vue&type=style&index=0&id=a1a2242e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a2242e",
  null
  
)

export default component.exports